import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import profileService from "services/profile/profile.service";
import * as utility from "utilities/utils";

export const getBusinessLogo = createAsyncThunk(
    "businessLogo/getBusinessLogo",
    async (_, { rejectWithValue }) => {
        try {
            return await profileService.getBusinessLogo();
        } catch (err) {
            return rejectWithValue(utility.getErrorResponse(err));
        }
    }
);


const businessLogoSlice = createSlice({
    name: "businessLogo",
    initialState: { data: {}, loading: false, error: null },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getBusinessLogo.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getBusinessLogo.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(getBusinessLogo.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });;

    }
});

export default businessLogoSlice.reducer;
